import { call, select } from 'redux-saga/effects';
import objectToQueryString from 'mz-utils/objectToQueryString';
import { getFullStorySessionURL } from 'app/utils/fullstory';
import { engage } from 'mz-sdk';
import _ from 'lodash';
import {
  getSavedBooking,
  getSavedSearch,
  getBookTripForm
} from 'app/sagas/selectors';
import { handleRefParam } from 'app/sagas/utils';
import { FIRST_NAME_FIELD_NAME, LAST_NAME_FIELD_NAME } from 'app/constants';

export default function* userEntersEmail({ payload }) {
  const saved = yield select(getSavedBooking);
  // TODO: this check should be removed after #1227 is closed
  if (!saved) return;
  const { provider, session_id } = saved;
  const savedSearch = yield select(getSavedSearch);
  if (_.isEmpty(savedSearch)) return;

  const form = yield select(getBookTripForm);
  const firstName = _.get(form, FIRST_NAME_FIELD_NAME);
  const lastName = _.get(form, LAST_NAME_FIELD_NAME);
  // Skip until the user has filled in their name.
  if (!firstName || !lastName) return;

  try {
    const { ref } = yield call(handleRefParam);
    const data = {
      email: payload,
      provider_name: provider,
      session_id,
      first_name: firstName,
      last_name: lastName,
      url: `${window.location.origin}/search/${objectToQueryString(savedSearch)}`,
      ref: ref || 'mozio_web'
    };

    const full_story_url = getFullStorySessionURL();

    if (full_story_url) {
      Object.assign(data, {
        extra_data: { full_story_url }
      });
    }

    yield call(engage.captureEmail, data);
  } catch (err) {
    // fails when the email is already saved
  }
}
